// Feedback #513 — derive default billing_status from matter billing_type.
//
// Rules:
//   hourly       → 'billable'         (work is billed hourly — attorney gets paid)
//   contingency  → 'no-charge-show'   (fee is on recovery, not hours — no charge to client for hours)
//   flat / retainer / null / other → firmDefault (unchanged behavior)
//
// The firm-wide default (window.__lextrackDefaultBillingStatus) is loaded on
// Layout mount from /api/settings.  All 3 timer surfaces (TimeEntries manual
// form, Layout global timer popup, TimerWidget Electron pop-out) call this
// helper on matter select so the default flips when the user picks a
// contingency matter (or vice versa).  A `billingStatusTouched` ref guards
// against clobbering a value the user has explicitly set.

export function firmDefaultBillingStatus () {
  const fromWindow = typeof window !== 'undefined' ? window.__lextrackDefaultBillingStatus : null
  return fromWindow || 'billable'
}

export function deriveDefaultBillingStatus (billingType, firmDefault) {
  const fallback = firmDefault || firmDefaultBillingStatus()
  switch ((billingType || '').toLowerCase()) {
    case 'hourly':      return 'billable'
    case 'contingency': return 'no-charge-show'
    // 'flat', 'retainer', 'pro_bono', anything else → let firm default win.
    // pro_bono in particular could be 'no-charge-show' at firm level; don't
    // override that with a hardcoded value here.
    default:            return fallback
  }
}
